import { render, staticRenderFns } from "./createdSuccess.vue?vue&type=template&id=a394632a&scoped=true"
import script from "./createdSuccess.vue?vue&type=script&lang=js"
export * from "./createdSuccess.vue?vue&type=script&lang=js"
import style0 from "./createdSuccess.vue?vue&type=style&index=0&id=a394632a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a394632a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a394632a')) {
      api.createRecord('a394632a', component.options)
    } else {
      api.reload('a394632a', component.options)
    }
    module.hot.accept("./createdSuccess.vue?vue&type=template&id=a394632a&scoped=true", function () {
      api.rerender('a394632a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/temporaryWorkerAccount/cmp/createdSuccess.vue"
export default component.exports